<div class="container pt-4">
    <nav>
        <div class="nav nav-tabs" id="nav-tab" role="tablist">
            <button class="nav-item nav-link active" id="t-0-tab" data-toggle="tab" href="#t-0" role="tab">{{ 'USERMANAGEMENT.MODAL_USER_DATA' | translate }}</button>
            <button [disabled]="isGuestAccount?.value" class="nav-item nav-link" id="t-1-tab" data-toggle="tab" href="#t-1" role="tab">
                {{ 'USERMANAGEMENT.MODAL_ADDRESS' | translate }}
            </button>
            <button [disabled]="isGuestAccount?.value" class="nav-item nav-link" id="t-2-tab" data-toggle="tab" href="#t-2" role="tab">
                {{ 'USERMANAGEMENT.MODAL_PAYMENT' | translate }}
            </button>
            <button class="nav-item nav-link" id="t-3-tab" data-toggle="tab" href="#t-3" role="tab">{{ 'CORE.COMMENT' | translate }}</button>
        </div>
    </nav>
    <div class="tab-content" [formGroup]="userForm" id="nav-tab-content">
        <div class="tab-pane fade show active" id="t-0" role="tabpanel">
            <div class="row">
                <div class="col-12 pt-4">
                    <app-data-tab formGroupName="userData" [editUser]="this.data !== null"></app-data-tab>
                </div>
            </div>
        </div>
        <div class="tab-pane fade" id="t-1" role="tabpanel">
            <div class="row">
                <div class="col-12 pt-4">
                    <app-address-data formGroupName="addressData"></app-address-data>
                </div>
            </div>
        </div>
        <div class="tab-pane fade" id="t-2" role="tabpanel">
            <div class="row">
                <div class="col-12 pt-4">
                    <app-payment-tab formGroupName="paymentData"></app-payment-tab>
                </div>
            </div>
        </div>
        <div class="tab-pane fade" id="t-3" role="tabpanel">
            <div class="row">
                <div class="col-12 pt-4">
                    <app-comment-tab formGroupName="commentData"></app-comment-tab>
                </div>
            </div>
        </div>
    </div>
    <div class="dialog-footer">
        <button type="button" class="btn btn-outline-secondary" (click)="close()">
            {{ 'CORE_BUTTON_CANCEL' | translate }}
        </button>
        <button type="button" class="btn btn-primary save" (click)="save()">
            {{ 'CORE_BUTTON_SAVE' | translate }}
        </button>
    </div>
</div>
